<!--
 * @Author: Scarlett Xiao
 * @Date: 2022-01-04 15:05:32
 * @LastEditors: zcy
 * @LastEditTime: 2022-03-01 15:47:45
-->
<template>
  <div class="page-main">
    <div class="page-type-switch">
      <div
        :class="pageType === 'cost-page' ? 'type-activite' : ''"
      >
        单位利润计划与实际比(育苗)
      </div>
    </div>
    <ConstPage v-if="pageType === 'cost-page'" />
  </div>
</template>

<script>
import ConstPage from "./ym-profit-page.vue"
export default {
  name: "ym",
  data() {
    return {
      pageType: "cost-page",
    };
  },
  computed: {},
  components:{
    ConstPage
  },
  methods: {
    
  },
  mounted() {
    // 模板编译/挂载之后
  },
  // 数据监听
  watch: {
    
  },
};
</script>

<style lang="less" scoped>
</style>